var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'logo-image-holder': !_vm.collapsed,
    'hyp-logo-link': !this.disableToggle,
  }},[_c('v-img',{staticClass:"hyp-logo",attrs:{"src":_vm.src,"contain":"","alt":"hyperion logo"},on:{"click":function($event){return _vm.toggle()}}},[(_vm.deployEnvStage)?_c('span',{staticClass:"hyp-logo-test"},[_vm._v(_vm._s(_vm.deployEnvStage)+" ENV")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }